import PropTypes from 'prop-types';
import Skeleton from 'react-loading-skeleton';
import '../styles/companionAppUsageReport.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTriangleExclamation } from '@fortawesome/pro-solid-svg-icons';

const YearOverYearAlert = ({ hasDeclineDetected = false, isLoading = false }) => {
  if (isLoading) {
    return (
      <div className="alert border-start border mb-3" role="alert">
        <div>
          <div className="d-flex align-items-center gap-2 mb-1">
            <Skeleton circle width={18} height={18} />
            <Skeleton width="260px" height="18px" />
          </div>
          <Skeleton width="100%" height="14px" />
        </div>
      </div>
    );
  }

  if (!hasDeclineDetected) {
    return null;
  }

  return (
    <div className="alert border-start border-danger mb-3 companion-year-over-year-alert-bg" role="alert">
      <div>
        <h6 className="alert-heading text-danger mb-1 d-flex align-items-center">
          <FontAwesomeIcon icon={faTriangleExclamation} />
          <strong className='mx-2'>Year-over-Year Decline Detected</strong>
        </h6>
        <p className="mb-0 text-muted">
          Multiple metrics show decreased usage compared to the same period last year. Review detailed comparisons below.
        </p>
      </div>
    </div>
  );
};

YearOverYearAlert.propTypes = {
  hasDeclineDetected: PropTypes.bool,
  isLoading: PropTypes.bool
};

export default YearOverYearAlert;
